import { brandPrimary, brandPrimaryDark, brandSecondary, white } from '../../styles/colors';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	selectContent: {
		background: brandPrimary,
		border: `1px solid ${brandSecondary}`,
	},
	selectItem: {
		background: brandPrimary,
		color: white,
		':hover': {
			background: brandPrimaryDark,
		},
	},
	selectRow: {
		alignItems: 'flex-end',
		display: 'flex',
		flexDirection: 'column',
		paddingBottom: 20,
	},
	selectTrigger: {
		background: brandPrimary,
		border: `1px solid ${brandSecondary}`,
		color: white,
	},
	settings: {
		paddingTop: 15,
	},
	settingsContainer: {},
});
